import styled from "styled-components/macro";

export const StyledContextMenu = styled.div`
display:  flex;
align-items: center;
justify-content: space-between;
    margin: 40px 0 20px 0;
`;